import { render } from "./TargetAgreementTable.vue?vue&type=template&id=7f4a9388&scoped=true"
import script from "./TargetAgreementTable.vue?vue&type=script&lang=js"
export * from "./TargetAgreementTable.vue?vue&type=script&lang=js"

import "./TargetAgreementTable.vue?vue&type=style&index=0&id=7f4a9388&scoped=true&lang=css"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4a9388"]])

export default __exports__